// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"sq_a bhm_rc bhm_qx bhm_xr","ForumPosts__contest":"sq_b bhm_hq","ForumPosts__counselling":"sq_c"};